import moment from 'moment';

const formatDate = (date: any, format: string) => {
  return moment(date).format(format);
};

export { formatDate };
